import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import React, { FunctionComponent } from 'react';

interface LogoutDialogProps {
  open: boolean;
  onCancel: () => void;
  onLogout: () => void;
}

export const LogoutDialog: FunctionComponent<LogoutDialogProps> = ({
  open,
  onCancel,
  onLogout,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onCancel}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{'Se déconnecter'}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          Êtes-vous sûr de vouloir vous déconnecter ?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel}>Annuler</Button>
        <Button onClick={onLogout} autoFocus sx={{ color: 'error.main' }}>
          Me déconnecter
        </Button>
      </DialogActions>
    </Dialog>
  );
};
